/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsOptimizeFieldConfigurationSchemeRoute } from '@jira/router-routes__admin-pages-fields-routes/src/globalSettingsOptimizeFieldConfigurationSchemeRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import {
	OptimizeFieldConfigurationSchemePage,
	LazyOptimizeFieldConfigurationSchemePagePage,
} from './ui/spa/admin-pages/fields/optimize-field-configuration-scheme-page/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsOptimizeFieldConfigurationSchemeRouteEntry: Route = createEntry(
	globalSettingsOptimizeFieldConfigurationSchemeRoute,
	() => ({
		group: 'global-settings',

		// eslint-disable-next-line no-restricted-syntax
		component: OptimizeFieldConfigurationSchemePage,

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyOptimizeFieldConfigurationSchemePagePage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
